export default {
  "mentionPalette": "qcOnx",
  "mention": "kk2d5",
  "mentionViewer": "QiAsM",
  "mentionSuggestionsEntry": "d188l",
  "mentionSuggestionsEntryFocused": "ca1SA",
  "mentionSuggestionsEntryText": "oG9lE",
  "mentionSuggestionsEntryAvatar": "_0dbNJ",
  "mentionSuggestions": "q5LQh",
  "cursorDefault": "_0ZtnB",
  "cursorPointer": "B5XfL"
};